import { lazy } from 'react';
import { CalendarDays, CalendarPlus } from 'lucide-react';
import type { CalendarEvent } from '@app/shared';
import type { WebModule } from '../../app/types.ts';
import { familyRecords, scoreText } from '../../platform/search.ts';
import { friendlyDay } from '../../platform/time.ts';

export const calendarModule: WebModule = {
  id: 'calendar',
  label: 'Calendar',
  icon: CalendarDays,
  path: '/calendar',
  nav: { group: 'main', order: 10, bottomTab: true },
  routes: [{ path: 'calendar', lazy: async () => ({ Component: (await import('./CalendarScreen.tsx')).CalendarScreen }) }],
  home: [
    { id: 'schedule', title: "Today's schedule", order: 20, component: lazy(() => import('./home.tsx').then((m) => ({ default: m.TodaySchedule }))) },
    { id: 'birthdays', title: 'Birthdays', order: 80, component: lazy(() => import('./home.tsx').then((m) => ({ default: m.UpcomingBirthdays }))) },
  ],
  quickActions: [{ id: 'event', label: 'Event', icon: CalendarPlus, to: '/calendar?new=1', adultOnly: true }],
  async search(q, ctx) {
    const events = await familyRecords<CalendarEvent>('events', ctx.familyId);
    return events
      .map((e) => ({ e, score: scoreText(q, [e.title, e.location, e.notes]) }))
      .filter((x) => x.score > 0)
      .map(({ e, score }) => {
        const start = e.allDay ? new Date(`${e.startDate}T00:00`) : new Date(e.startsAt!);
        return {
          key: `events:${e.id}`,
          title: e.title,
          subtitle: `${friendlyDay(start)}${e.recurrence ? ' · repeats' : ''}${e.location ? ` · ${e.location}` : ''}`,
          to: `/calendar?event=${e.id}`,
          group: 'Calendar',
          icon: CalendarDays,
          score,
        };
      });
  },
};
